import React from "react";
import { useParams, useLocation, useSearchParams } from "react-router-dom";
import CanvasForm from "./components/CanvasForm";

/**
 * CanvasPage - Optimized wrapper component for both add and edit modes
 *
 * Handles both add and edit routes:
 * - /add-new-canvas/:partnumber/:revision/:partId/:revisionId/:section_id_ref/:step_id_ref
 * - /edit-canvas-new/:partnumber/:revision/:partId/:revisionId/:section_id_ref/:step_id_ref/:id
 * - /edit-canvas/:sectionId/:partId/:revisionId/:stepId/:substepId/:partNumber/:elementTitle/:revision/:stepTitle/:section/:siblingOrder/:elementType/:id (legacy)
 *
 * Key improvements over CanvasOld:
 * - Minimal location state dependencies
 * - URL parameter extraction
 * - Clean separation of concerns
 * - Better error handling
 * - Single file handles both add and edit modes
 */
const CanvasPage = () => {
  const location = useLocation();
  const params = useParams();
  const [searchParams] = useSearchParams();

  // Extract URL parameters (supports both new and old route patterns)
  const {
    partnumber,
    partNumber, // old route pattern
    revision,
    partId,
    revisionId,
    section_id_ref,
    sectionId, // old route pattern
    step_id_ref,
    stepId, // old route pattern
    substep_id_ref,
    substepId, // old route pattern
    node_id_ref,
    id,
  } = params;

  // Extract query parameters
  const substep_id_ref_query = searchParams.get("substep_id_ref");
  const node_id_ref_query = searchParams.get("node_id_ref");

  // Determine mode from path
  const mode = location.pathname.includes("/edit-canvas") ? "edit" : "add";

  // Extract state data (fallback for legacy compatibility)
  const { fromVersionHistory, versionHistoryData, data } = location.state || {};

  return (
    <CanvasForm
      mode={mode}
      fromVersionHistory={fromVersionHistory}
      versionHistoryData={versionHistoryData}
      data={data}
      // Pass all URL parameters (new pattern takes precedence over old pattern)
      partnumber={partnumber || partNumber}
      revision={revision}
      partId={partId}
      revisionId={revisionId}
      section_id_ref={section_id_ref || sectionId}
      step_id_ref={step_id_ref || stepId}
      substep_id_ref={substep_id_ref || substepId || substep_id_ref_query}
      node_id_ref={node_id_ref || node_id_ref_query}
      id={id}
    />
  );
};

export default CanvasPage;
